import React, { useEffect, useRef, useState } from "react";
import {  useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import Tabs from "../../../components/Tabs/Tabs";
import NftCard from "../../../components/NftCard/NftCard";
import Pagination from "../../../components/Pagination/Pagination";
import ShowMinted from "../../../components/ShowMinted/ShowMinted";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledLgText from "../../../common/components/styledLgText/StyledLgText";
import StyledH2Heading from "../../../common/components/styledH2Heading/StyledH2Heading";
import StyledH5Heading from "../../../common/components/styledH5Heading/StyledH5Heading";
import { useNft } from "../../../Hooks/api/useNft";
import NFTSkeltonLoader from "../../../components/Loader/nft-skelton-loader";
import useScrollToTop from "../../../utils/useScrollToTop";


const CollectionNfts = ({ custom }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const walletAddress = useSelector((state) => state.user.walletAddress);
  
  const location = useLocation();
 

  const queryParams = new URLSearchParams(location.search);
  const page = parseInt(queryParams.get("page")) || 1;
  const [activeCategory, setActiveCategory] = useState("Tier 1");
  const [activeTab, setActiveTab] = useState("All");
  const collectionRef = useRef(null);
  useEffect(() => {
    if (collectionRef.current) {
      collectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setCurrentPage(page);
  }, [page]);

useScrollToTop()

  const {
    data,
    isLoading,
  } = useNft({
    page,
    perPage: 12,
    tier: activeCategory.replace(/\s+/g, ""),
    walletAddress: walletAddress,
    minted: activeTab === "Minted" ? true : activeTab === "Not Minted" ? false : undefined,
  });
  
  const meta = data?.totalPages;
  const nfts = data?.data;

  const [currentPage, setCurrentPage] = useState(page);
  const handlePageChange = ({ selected }) => {
    searchParams.set("page", selected + 1);
    setSearchParams(searchParams);
    setCurrentPage(selected + 1);
  };

  const handleTabClick = (tab) => {
    searchParams.set("page", 1); 
    setSearchParams(searchParams);
    setActiveTab(tab);
  };

  const handleCategoryClick = (index, category) => {
    searchParams.set("page", 1); 
    setSearchParams(searchParams);
    setActiveCategory(category);
  };

  const styles = {
    backgroundSize: "auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundImage: "url('/assets/golden-collection-shadow.png')",
  };



  return (
    <div style={styles} className="flex items-center justify-center w-full">
      <div className="w-[100%] sm:w-[100%] md:w-[80%] flex flex-col justify-center items-center gap-14 md:gap-20 pt-10 md:pt-16 pb-10">
        {!custom && (
        
          <div ref={collectionRef} className="flex flex-col items-center justify-center w-[80%] sm:w-[60%] mx-auto gap-1 text-center md:w-1/2 lg:w-[45%]">
            <StyledH5Heading fontColor={"-mb-2"}>Golden Year</StyledH5Heading>
            <StyledH2Heading fontColor={"textGradient"}>
              Collection
            </StyledH2Heading>
            <StyledMdText>
              Golden Year presents a unique 5 Tier based Golden NFT’s for our
              curated customers.
            </StyledMdText>
          </div>
        )}
        <div className="w-full flex flex-col justify-center items-center gap-5">
          <div className="flex flex-col-reverse w-full gap-7 lg:gap-3 lg:flex-row">
            <Tabs
              data={[
                { Title: "Tier 1" },
                { Title: "Tier 2" },
                { Title: "Tier 3" },
                { Title: "Tier 4" },
                { Title: "Tier 5" },
                { Title: "Metaverse" },
              ]}
              activeCategory={activeCategory}
              handleCategoryClick={handleCategoryClick}
              width={"w-full lg:w-[70%]"}
            />
            <ShowMinted
              data={[
                { title: "All" },
                { title: "Minted" },
                { title: "Not Minted" },
              ]}
              handleTabClick={handleTabClick}
              activeTab={activeTab}
              width={"w-[90%] sm:w-[85%] mx-auto lg:w-[34%]"}
            />
          </div>
          {isLoading ? (
            <div
              className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 w-[90%] sm:w-[85%] md:w-full mx-auto"
              style={{ minHeight: "300px" }}
            >
              {Array.from({ length: 12 }).map((_, index) => (
                <NFTSkeltonLoader />
              ))}
            </div>
          ) : nfts?.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 w-[90%] sm:w-[85%] md:w-full mx-auto">
              {nfts?.map((nft, index) => (
           
                <NftCard key={index} nft={nft} minted={nft.minted} />
            
               
              ))}
            </div>
          ) : (
            <div className=" flex flex-col gap-10 justify-center items-center h-[300px] ">
              <img src="/assets/not-found.svg" alt="not found icon" loading="lazy"/>
             <div className="text-white text-center">
             <StyledH5Heading >
              No Nft’s Available
              </StyledH5Heading>
              <StyledLgText>
              Looks like there are no NFT’s in this collection.
              </StyledLgText>
             </div>
            </div>
          )}

          <div className="w-full px-2">
            {!isLoading && nfts?.length > 0 && (
              <Pagination
                initialPage={currentPage - 1}
                pageCount={meta || 0}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollectionNfts;
